// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:03 GMT

export const website_desktop_tailwind_config = {
  spacing: {
    "frame-header-md-expanded-height": "9rem",
    "dynamic-mobile-frame-header-md-expanded-height": "20.224719101123597vh",
    "dynamic-desktop-frame-header-md-expanded-height": "13.333333333333334vh",
    "frame-header-md-expanded-width": "120rem",
    "dynamic-mobile-frame-header-md-expanded-width": "533.3333333333334vw",
    "dynamic-desktop-frame-header-md-expanded-width": "100vw",
    "frame-review-1-height": "16.375rem",
    "dynamic-mobile-frame-review-1-height": "36.79775280898876vh",
    "dynamic-desktop-frame-review-1-height": "24.25925925925926vh",
    "frame-review-1-width": "38.875rem",
    "dynamic-mobile-frame-review-1-width": "172.77777777777777vw",
    "dynamic-desktop-frame-review-1-width": "32.395833333333336vw",
    "frame-review-2-height": "16.375rem",
    "dynamic-mobile-frame-review-2-height": "36.79775280898876vh",
    "dynamic-desktop-frame-review-2-height": "24.25925925925926vh",
    "frame-review-2-width": "38.875rem",
    "dynamic-mobile-frame-review-2-width": "172.77777777777777vw",
    "dynamic-desktop-frame-review-2-width": "32.395833333333336vw",
    "frame-bg-1-height": "52.25rem",
    "dynamic-mobile-frame-bg-1-height": "117.41573033707866vh",
    "dynamic-desktop-frame-bg-1-height": "77.4074074074074vh",
    "frame-bg-1-width": "102.25rem",
    "dynamic-mobile-frame-bg-1-width": "454.44444444444446vw",
    "dynamic-desktop-frame-bg-1-width": "85.20833333333333vw",
    "cta-entryfield-1-height": "5rem",
    "dynamic-mobile-cta-entryfield-1-height": "11.235955056179776vh",
    "dynamic-desktop-cta-entryfield-1-height": "7.407407407407407vh",
    "cta-entryfield-1-width": "54.875rem",
    "dynamic-mobile-cta-entryfield-1-width": "243.88888888888889vw",
    "dynamic-desktop-cta-entryfield-1-width": "45.729166666666664vw",
    "cta-button-1-height": "5rem",
    "dynamic-mobile-cta-button-1-height": "11.235955056179776vh",
    "dynamic-desktop-cta-button-1-height": "7.407407407407407vh",
    "cta-button-1-width": "22.875rem",
    "dynamic-mobile-cta-button-1-width": "101.66666666666667vw",
    "dynamic-desktop-cta-button-1-width": "19.0625vw",
    "cta-button-2-height": "4.5rem",
    "dynamic-mobile-cta-button-2-height": "10.112359550561798vh",
    "dynamic-desktop-cta-button-2-height": "6.666666666666667vh",
    "cta-button-2-width": "18.5rem",
    "dynamic-mobile-cta-button-2-width": "82.22222222222223vw",
    "dynamic-desktop-cta-button-2-width": "15.416666666666666vw",
    "cta-button-3-height": "2.5rem",
    "dynamic-mobile-cta-button-3-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-3-height": "3.7037037037037037vh",
    "cta-button-3-width": "8.75rem",
    "dynamic-mobile-cta-button-3-width": "38.888888888888886vw",
    "dynamic-desktop-cta-button-3-width": "7.291666666666667vw",
    "cta-banner-1-height": "17.5rem",
    "dynamic-mobile-cta-banner-1-height": "39.325842696629216vh",
    "dynamic-desktop-cta-banner-1-height": "25.925925925925927vh",
    "cta-banner-1-width": "79rem",
    "dynamic-mobile-cta-banner-1-width": "351.1111111111111vw",
    "dynamic-desktop-cta-banner-1-width": "65.83333333333333vw",
    "cta-categories-1-height": "25rem",
    "dynamic-mobile-cta-categories-1-height": "56.17977528089887vh",
    "dynamic-desktop-cta-categories-1-height": "37.03703703703704vh",
    "cta-categories-1-width": "18.75rem",
    "dynamic-mobile-cta-categories-1-width": "83.33333333333333vw",
    "dynamic-desktop-cta-categories-1-width": "15.625vw",
    "cta-categories-2-height": "25rem",
    "dynamic-mobile-cta-categories-2-height": "56.17977528089887vh",
    "dynamic-desktop-cta-categories-2-height": "37.03703703703704vh",
    "cta-categories-2-width": "18.75rem",
    "dynamic-mobile-cta-categories-2-width": "83.33333333333333vw",
    "dynamic-desktop-cta-categories-2-width": "15.625vw",
    "cta-categories-3-height": "25rem",
    "dynamic-mobile-cta-categories-3-height": "56.17977528089887vh",
    "dynamic-desktop-cta-categories-3-height": "37.03703703703704vh",
    "cta-categories-3-width": "18.75rem",
    "dynamic-mobile-cta-categories-3-width": "83.33333333333333vw",
    "dynamic-desktop-cta-categories-3-width": "15.625vw",
    "cta-categories-4-height": "25rem",
    "dynamic-mobile-cta-categories-4-height": "56.17977528089887vh",
    "dynamic-desktop-cta-categories-4-height": "37.03703703703704vh",
    "cta-categories-4-width": "18.75rem",
    "dynamic-mobile-cta-categories-4-width": "83.33333333333333vw",
    "dynamic-desktop-cta-categories-4-width": "15.625vw",
  },
  colors: {
    "frame-header-md-expanded-borderColor": "#333333",
    "frame-header-md-expanded-fill": "#121212",
    "frame-review-1-fill": "#191919",
    "frame-review-2-fill": "#202020",
    "frame-bg-1-fill": "#202020",
    "cta-entryfield-1-fill": "#191919",
    "cta-entryfield-1-borderColor": "#333333",
    "cta-button-1-fill": "#202020",
    "cta-button-1-borderColor": "#333333",
    "cta-button-2-fill": "#3929F2",
    "cta-button-3-fill": "#3929F2",
    "cta-banner-1-fill": "#89B996",
    "cta-categories-1-fill": "#A5B5FF",
    "cta-categories-2-fill": "#EEAB5E",
    "cta-categories-3-fill": "#5DC780",
    "cta-categories-4-fill": "#BA94C1",
    "on-bg-7": "#121212",
    "on-bg-10": "#191919",
    "on-bg-12": "#202020",
    "on-bg-15": "#262626",
    "on-bg-20": "#333333",
    "on-bg-25": "#404040",
    "on-bg-30": "#4C4C4C",
    "on-bg-35": "#595959",
    "on-bg-40": "#666666",
    "on-bg-45": "#737373",
    "on-bg-55": "#8C8C8C",
    "on-bg-60": "#999999",
    "on-bg-65": "#A6A6A6",
    "on-bg-70": "#B2B2B2",
    "on-bg-80": "#CCCCCC",
    "on-bg-85": "#D9D9D9",
    "on-bg-90": "#E5E5E5",
    "on-bg-95": "#F2F2F2",
    "on-bg-100": "#FFFFFF",
    "uniq-1": "#89B996",
    "primary-100": "#4364EF",
    "primary-130": "#7B93F4",
    "primary-150": "#A1B1F7",
    "primary-160": "#B4C1F9",
  },
  borderWidth: {
    "frame-header-md-expanded-borderWidthBottom": "0.0625rem",
    "cta-entryfield-1-borderWidth": "0.0625rem",
    "cta-button-1-borderWidth": "0.0625rem",
  },
  borderRadius: {
    "frame-review-1-borderRadius": "1rem",
    "frame-review-2-borderRadius": "1rem",
    "frame-bg-1-borderRadius": "1.375rem",
    "cta-entryfield-1-borderRadius": "0.75rem",
    "cta-button-1-borderRadius": "0.75rem",
    "cta-button-2-borderRadius": "0.75rem",
    "cta-button-3-borderRadius": "0.375rem",
    "cta-banner-1-borderRadius": "1rem",
    "cta-categories-1-borderRadius": "0.75rem",
    "cta-categories-2-borderRadius": "0.75rem",
    "cta-categories-3-borderRadius": "0.75rem",
    "cta-categories-4-borderRadius": "0.75rem",
  },
  fontFamily: {
    "cta-typo-1-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-2-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-3-fontFamilies": "Circular Std, sans-serif",
    "body-lg1_1-fontFamily": "Circular Std, sans-serif",
    "body-lg1_2-fontFamily": "Circular Std, sans-serif",
    "body-md1_1-fontFamily": "Circular Std, sans-serif",
    "body-md1_2-fontFamily": "Circular Std, sans-serif",
    "body-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md2_2-fontFamily": "Circular Std, sans-serif",
    "body-md3_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_2-fontFamily": "Circular Std, sans-serif",
    "body-md3_3-fontFamily": "Circular Std, sans-serif",
    "body-sm_1-fontFamily": "Circular Std, sans-serif",
    "body-sm2_1-fontFamily": "Circular Std, sans-serif",
    "title-lg1_1-fontFamily": "Circular Std, sans-serif",
    "title-lg2_1-fontFamily": "Circular Std, sans-serif",
  },
  fontWeight: {
    "cta-typo-1-fontWeights": 400,
    "cta-typo-2-fontWeights": 300,
    "cta-typo-3-fontWeights": 700,
    "body-lg1_1-fontWeight": 700,
    "body-lg1_2-fontWeight": 400,
    "body-md1_1-fontWeight": 400,
    "body-md1_2-fontWeight": 700,
    "body-md2_1-fontWeight": 500,
    "body-md2_2-fontWeight": 400,
    "body-md3_1-fontWeight": 300,
    "body-md3_2-fontWeight": 400,
    "body-md3_3-fontWeight": 500,
    "body-sm_1-fontWeight": 400,
    "body-sm2_1-fontWeight": 400,
    "title-lg1_1-fontWeight": 700,
    "title-lg2_1-fontWeight": 700,
  },
  fontSize: {
    "cta-typo-1-fontSizes": "1.5rem",
    "cta-typo-2-fontSizes": "1.125rem",
    "cta-typo-3-fontSizes": "2.5rem",
    "body-lg1_1-fontSize": "2.5rem",
    "body-lg1_2-fontSize": "2.5rem",
    "body-md1_1-fontSize": "1.5rem",
    "body-md1_2-fontSize": "1.5rem",
    "body-md2_1-fontSize": "1.25rem",
    "body-md2_2-fontSize": "1.25rem",
    "body-md3_1-fontSize": "2rem",
    "body-md3_2-fontSize": "2rem",
    "body-md3_3-fontSize": "2rem",
    "body-sm_1-fontSize": "1rem",
    "body-sm2_1-fontSize": "1.125rem",
    "title-lg1_1-fontSize": "3rem",
    "title-lg2_1-fontSize": "4rem",
  },
  lineHeight: {
    "cta-typo-1-lineHeights": "inherit",
    "cta-typo-2-lineHeights": "inherit",
    "cta-typo-3-lineHeights": "inherit",
    "body-lg1_1-lineHeight": "inherit",
    "body-lg1_2-lineHeight": "inherit",
    "body-md1_1-lineHeight": "inherit",
    "body-md1_2-lineHeight": "inherit",
    "body-md2_1-lineHeight": "inherit",
    "body-md2_2-lineHeight": "inherit",
    "body-md3_1-lineHeight": "inherit",
    "body-md3_2-lineHeight": "inherit",
    "body-md3_3-lineHeight": "inherit",
    "body-sm_1-lineHeight": "inherit",
    "body-sm2_1-lineHeight": "inherit",
    "title-lg1_1-lineHeight": "inherit",
    "title-lg2_1-lineHeight": "inherit",
  },
  letterSpacing: {
    "cta-typo-1-letterSpacing": "0rem",
    "cta-typo-2-letterSpacing": "0rem",
    "cta-typo-3-letterSpacing": "0rem",
    "body-lg1_1-letterSpacing": "0rem",
    "body-lg1_2-letterSpacing": "0rem",
    "body-md1_1-letterSpacing": "0rem",
    "body-md1_2-letterSpacing": "0rem",
    "body-md2_1-letterSpacing": "0rem",
    "body-md2_2-letterSpacing": "0rem",
    "body-md3_1-letterSpacing": "0rem",
    "body-md3_2-letterSpacing": "0rem",
    "body-md3_3-letterSpacing": "0rem",
    "body-sm_1-letterSpacing": "0rem",
    "body-sm2_1-letterSpacing": "0rem",
    "title-lg1_1-letterSpacing": "0rem",
    "title-lg2_1-letterSpacing": "0rem",
  },
};

export const website_desktop_plugin_components = {
  ".typography-cta-typo-1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "1.5rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    fontSize: "1.125rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "2.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "2.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "2rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "2rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "2rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "1.125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "3rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "4rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".composition-frame-header-md-expanded": {
    height: "9rem",
    width: "120rem",
    borderColor: "#333333",
    backgroundColor: "#121212",
    borderBottomWidth: "0.0625rem",
  },
  ".composition-frame-review-1": {
    height: "16.375rem",
    width: "38.875rem",
    backgroundColor: "#191919",
    borderRadius: "1rem",
  },
  ".composition-frame-review-2": {
    height: "16.375rem",
    width: "38.875rem",
    backgroundColor: "#202020",
    borderRadius: "1rem",
  },
  ".composition-frame-bg-1": {
    height: "52.25rem",
    width: "102.25rem",
    backgroundColor: "#202020",
    borderRadius: "1.375rem",
  },
  ".composition-cta-entryfield-1": {
    height: "5rem",
    width: "54.875rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
    borderColor: "#333333",
  },
  ".composition-cta-button-1": {
    height: "5rem",
    width: "22.875rem",
    backgroundColor: "#202020",
    borderRadius: "0.75rem",
    borderColor: "#333333",
  },
  ".composition-cta-button-2": {
    height: "4.5rem",
    width: "18.5rem",
    backgroundColor: "#3929F2",
    borderRadius: "0.75rem",
  },
  ".composition-cta-button-3": {
    height: "2.5rem",
    width: "8.75rem",
    borderRadius: "0.375rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-banner-1": {
    height: "17.5rem",
    width: "79rem",
    backgroundColor: "#89B996",
    borderRadius: "1rem",
  },
  ".composition-cta-categories-1": {
    height: "25rem",
    width: "18.75rem",
    backgroundColor: "#A5B5FF",
    borderRadius: "0.75rem",
  },
  ".composition-cta-categories-2": {
    height: "25rem",
    width: "18.75rem",
    backgroundColor: "#EEAB5E",
    borderRadius: "0.75rem",
  },
  ".composition-cta-categories-3": {
    height: "25rem",
    width: "18.75rem",
    backgroundColor: "#5DC780",
    borderRadius: "0.75rem",
  },
  ".composition-cta-categories-4": {
    height: "25rem",
    width: "18.75rem",
    backgroundColor: "#BA94C1",
    borderRadius: "0.75rem",
  },
};
